import formatter from './format.helper'

class NotificationHelper {
  //
  camelize (string) {
    if (typeof string !== 'string') {
      return
    }
    return string.replace(/[_.-:](\w|$)/g, function (match, $) {
      return $.toUpperCase()
    })
  }

  toHtml (text, bindings) {
    bindings = bindings || []

    for (let key in bindings) {
      if (!bindings.hasOwnProperty(key)) {
        continue
      }
      const attribute = this.camelize(key)

      console.log(attribute)
      if (typeof formatter['format' + attribute] !== 'undefined') {
        let replacement = formatter['format' + attribute](bindings[key])
        text = text.replace(key, replacement)
      } else {
        text = text.replace(key, bindings[key])
      }
    }
    return text
  }

  convert (notification) {
    if (notification.data) {
      return (this.toHtml(notification.data.content || '', notification.data.bindings || []))
    } else {
      return notification.title
    }
  }
}

const notificationHelper = new NotificationHelper()
export default notificationHelper
